import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import useDebounce from '../../hooks/useDebounce';
import Iconify from '../Iconify';
import '../../css/contracts/contractFiltration.css';

const ContractsFiltration = ({ filtersEmpty, contractFilters, setContractfilters, totalContracts, filteredContractsCount, contractsFetched }) => {


    const [search, setSearch] = useState(contractFilters.debouncedSearch || '');
    const debouncedSearch = useDebounce(search, 1000);

    // Update filters when debounced search changes
    useEffect(() => {
        setContractfilters((prev) => ({ ...prev, debouncedSearch: debouncedSearch }));
    }, [debouncedSearch, setContractfilters]);

    const clearFilters = useCallback(() => {
        setContractfilters({
            debouncedSearch: '',
            company: '',
            date: null,
            auto_renew: null
        });
        setSearch('');
    }, [setContractfilters, setSearch]);

    return (
        <Box className='contractFiltration_main_box'>
            <Box className='contractFiltration_counts'>
                <Box className='contractFiltration_search_clear_box'>
                    <TextField
                        size="small"
                        value={search}
                        placeholder='Rechercher'
                        onChange={(e) => setSearch(e.target.value)}
                        variant="outlined"
                        className='contractFiltration_search_Box'
                        InputProps={{
                            startAdornment: <Iconify icon="bx:bx-search" className='contractFiltration_search_icon' />,
                            sx: {
                                backgroundColor: '#fff',
                                height: '36px',
                                fontFamily: 'Mulish',
                                color: '#201E1E',
                                fontSize: '14px',
                                fontWeight: 400,
                            },
                        }}
                    />

                    <Typography className='contractFiltration_clearAll' onClick={clearFilters}>Re-initialiser</Typography>
                </Box>
                <Typography className='usersFiltration_total_number'>
                    {contractsFetched} affichés
                    {!filtersEmpty && ` / ${filteredContractsCount} filtrés`}
                    {` / ${totalContracts} au total`}
                </Typography>
            </Box>
        </Box>
    );
};

export default ContractsFiltration;